import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import { Row, Col } from "react-bootstrap";
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function AutocompleteInput(props) {

  const { errors, selectOptions, id, variant, onChange, value,onInputChange,disabled,filterOptions, ...textFieldProps } = props;

  return (
    <Row>
      <Col xs={12}>
        <FormControl
          fullWidth
          variant={variant || "filled"}
          error={!!errors}
        >
          <Autocomplete
            id={id}
            value={value}
            options={selectOptions}
            onChange={(event, newValue) => {
              if (newValue === null)
                onChange("");
              else
                onChange(newValue.value);
            }}
            onInputChange={onInputChange}
            disabled={disabled}
            filterOptions ={filterOptions}
            getOptionLabel={(option) => option.label}
            inputProps={props.inputProps} 
            renderInput={(params) => <TextField {...params} inputProps={{ ...params.inputProps, maxLength: 25}} label={props.label} variant={variant || "filled"} />}
          />
          <FormHelperText>{errors && errors.message}</FormHelperText>
        </FormControl>
      </Col>
    </Row>
  )
}

AutocompleteInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
  errors: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/AutocompleteInput.js